var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_227)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2578 5.03113C15.9918 5.4335 16.6551 6.44745 17.4867 7.84302H14.2578V5.03113ZM4.12415 7.96021C4.46365 7.96021 4.71008 8.12408 4.71008 8.50708C4.71008 8.83011 4.4487 9.0921 4.12582 9.09302H0.585938C0.262299 9.09302 0 9.35547 0 9.67896C0 10.0026 0.262299 10.2649 0.585938 10.2649H5.85938C6.18607 10.2649 6.4476 10.527 6.4476 10.8508C6.4476 11.1745 6.1853 11.4368 5.86166 11.4368H0.585938C0.262299 11.4368 0 11.6991 0 12.0227C0 12.3463 0.262299 12.6086 0.585938 12.6086H1.875V14.3665C1.875 14.6901 2.1373 14.9524 2.46094 14.9524H3.63876C3.84872 15.9866 4.76257 16.7493 5.83984 16.7493C6.91711 16.7493 7.83096 15.9866 8.04092 14.9524H13.9903C14.2003 15.9866 15.1141 16.7493 16.1914 16.7493C17.2687 16.7493 18.1825 15.9866 18.3925 14.9524H19.4141C19.7377 14.9524 20 14.6901 20 14.3665V10.8508C20 9.13162 18.1866 9.01749 18.185 9.01489H13.6719C13.3482 9.01489 13.0859 8.75259 13.0859 8.42896V4.91333H2.46094C2.1373 4.91333 1.875 5.17563 1.875 5.49927V6.78833H1.17188C0.848236 6.78833 0.585938 7.05063 0.585938 7.37427C0.585938 7.69791 0.848236 7.96021 1.17188 7.96021H4.12415ZM16.951 13.7436C17.3705 14.1631 17.3705 14.8434 16.951 15.2629C16.2762 15.9377 15.1172 15.4576 15.1172 14.5032C15.1172 13.5489 16.2762 13.0688 16.951 13.7436ZM6.59943 13.7436C7.01889 14.1631 7.01889 14.8434 6.59943 15.2629C5.92468 15.9377 4.76562 15.4576 4.76562 14.5032C4.76562 13.5489 5.92468 13.0688 6.59943 13.7436Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.85083)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.4d4bbbf8af64f48a27f5d14537d7fe53.svg";
export { ForwardRef as ReactComponent };